export const loginAction = (data) => ({
  type: 'LOGIN',
  data: data,
});
